export default "__VITE_ASSET__e9857397__"